import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { HttpHelper } from '../shared/http-helper';
import { AirportOperations } from './airport-operations';
import { BasedAircraft } from './based-aircraft';
import { Enplanements } from './enplanements';
import { TraconOperations } from '../system-management/tracon-models/tracon-operations';
import { UserSession } from '../shared/user-session';

import * as _ from 'lodash';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class ScenarioService {
    private _baseScenarioUrl = 'api/scenario';
    
    constructor(private _httpHelper: HttpHelper){}

    public getScenario(scenarioId: number): Observable<IScenario>{
        return this._httpHelper.get(`${this._baseScenarioUrl}/${scenarioId}`);
    }

    public getScenarios(userId: number): Observable<IScenario[]>{
        return this._httpHelper.get(`${this._baseScenarioUrl}/list/${userId}`);
    }

    public getRegionalReviewScenarios(userId: number): Observable<IScenario[]>{
        return this._httpHelper.get(`${this._baseScenarioUrl}/regionalreviewlist/${userId}`);
    }

    public getMergeListScenarios(type: string, userId: number):Observable<IScenario[]>{
        return this._httpHelper.get(`${this._baseScenarioUrl}/mergelist/${type}/${userId}`);
    }
    
    public getDeleteListScenarios (userId: number): Observable<IScenario[]>{        
        return this._httpHelper.get(`${this._baseScenarioUrl}/deletelist/${userId}`);
    }

    public createScenario(request: CreateScenarioRequest): Observable<CreateScenarioResponse>{
        return this._httpHelper.post(`${this._baseScenarioUrl}/create`, request);
    }

    public deleteScenarios(ids: number[]): Observable<string>{
        return this._httpHelper.post(`${this._baseScenarioUrl}/delete`, ids);
    }

    public updateCommitScenario(request: UpdateCommitScenarioRequest): Observable<UpdateCommitScenarioResponse>{
        return this._httpHelper.post(`${this._baseScenarioUrl}/updatecommit`, request);
    }

    public modifyScenarioFacilities(request: ModifyScenarioFacilitiesRequest): Observable<ModifyScenarioFacilitiesResponse>{
        return this._httpHelper.post(`${this._baseScenarioUrl}/modifyscenariofacilities`, request);
    }

    public executeReforecast(request: ScenarioForecastRequest): Observable<ScenarioForecastResponse>{
        return this._httpHelper.post(`${this._baseScenarioUrl}/forecast`, request);
    }
}

/* Definition of the Scenario entity */
export interface IScenario {
    id: number;
    userLevel: number;
    scenarioName: string;
    owner: string;
    userNotes: string;
    histNotes: string;
    updatedFlag: number;
    lastUpdated: string;
    baseFlag: number;
    enplanementlag: number;
    lopsFlag: number;
    aopsFlag: number;
    apprFlag: number;
    facCrit: string;
    setup: number;
    public: number;
    userId: number;
    traceopsFlag: number;
}

export class CreateScenarioRequest {
    userId: number;
    baseScenarioId: number;
    scenarioName: string;
    source: string;
    facilities: string[];
    public: boolean;

    updateSessionState(){
        sessionStorage.setItem('create-scenario-request', JSON.stringify(this));
    }

    getSession(): CreateScenarioRequest{
        if(sessionStorage.getItem('create-scenario-request') === null)
            return null;

        let storedRq:CreateScenarioRequest = JSON.parse(sessionStorage.getItem('create-scenario-request')) as CreateScenarioRequest;
        this.baseScenarioId = storedRq.baseScenarioId;
        this.facilities = storedRq.facilities;
        this.public = storedRq.public;
        this.scenarioName = storedRq.scenarioName;
        this.source = storedRq.source;
        this.userId = storedRq.userId;
        
        return(this);
    }

    destroySession(){
        sessionStorage.removeItem('create-scenario-request');
    }

    hasValidSession():boolean {
        return sessionStorage.getItem('create-scenario-request') !== null;
    }
}

export class CreateScenarioResponse {
    responseStatus: string;
    responseMessage: string;
}

export class UpdateCommitScenarioRequest{
    public userId: number;
    public scenarioSourceId: number;
    public scenarioSourceName: string;
    public scenarioTargetId: number;
    public scenarioTargetName: string;
    public all: number;
    public towerWithoutRadar: number;
    public tracon: number;
    public combinedTraconTower: number;
    public combinedNonRadarTower: number;
    public towerWithDisplay: number;
    public combinedControlFacility: number;
    public towerWithRadar: number;
    public enrouteCenter: number;
    public combinedTracon: number;
    public faaContractTower: number;
    public nonFaaFacility: number;
    public aopsFlag: number;
    public trFlag: number;
    public baFlag: number;
    public enplFlag: number;
    public preserveFlag: number;
}

export class UpdateCommitScenarioResponse {
    public responseStatus: string;
    public responseMessage: string;
}

export class ModifyScenarioFacilitiesRequest {
    public operation: string;
    public locIds: string[];
    public currentScenarioId: number;
    public deleteScenarioId: number;
    public sourceScenarioId: number;
    public targetScenarioId: number;
    public Overwrite: boolean;
}

export class ModifyScenarioFacilitiesResponse{
    public invalidDeletedLocIds: string[];
    public deletedLocIds: string[];
    public notFoundLocIds: string[];
    public overwrittenLocIds: string[];
    public existingLocIds: string[];
    public processedLocIds: string[];
    public currentScenarioId: number;
}

export class ScenarioForecastRequest{
    scenarioId: number;
    startYear: number;
    endYear: number;
    airportOperations: AirportOperations;
    basedAircraft: BasedAircraft;
    enplanements: Enplanements;
    traconOperations: TraconOperations;

    setNameInSession(name: string):void {
        sessionStorage.setItem('reforecast-scenario-name', name);
    }

    getNameInSession():string {
        return sessionStorage.getItem('reforecast-scenario-name');
    }

    destroySessionValues():void {
        sessionStorage.removeItem('reforecast-scenario-name');
    }
}

export class ScenarioForecastResponse {
    public responseStatus: string;
    public responseMessage: string;
}


/** WEBPACK FOOTER **
 ** ./app/scenario-activities/scenario.service.ts
 **/